<script setup>
import {useAuthService} from "~/composables/useAuthService";
import {useNavigationItems} from "~/composables/useNavigationItems";
import {useRoute} from "vue-router";

const route = useRoute();
const {isAuthenticated} = useAuthService();
const {mainMenuItems} = useNavigationItems();
const currentRoute = computed(() => route.path);
</script>

<template>
  <nav class="main-menu d-none d-md-block" role="menubar">
    <template v-for="item in mainMenuItems" :key="item.title+'item'">
      <v-menu v-if="item.subItems" :open-on-hover="true" :open-on-click="true" role="menu">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" :key="item.title + 'item'"
                 :to="item.link"
                 :class="item.link === currentRoute || item.subItems.filter(_ => _.link === currentRoute || (_.link.indexOf('case-studies') > -1 && currentRoute.indexOf('case-studies') > -1)).length > 0 || item.subItems.filter(_ => _.subItems !== undefined && _.subItems.filter(si => si.link === currentRoute).length > 0).length > 0 ? 'active' : ''"
                 role="menuitem">
            <v-icon :color="item.iconColor ?? 'primary'" size="14" class="mr-1" v-if="item.icon"
                    :icon="item.icon"></v-icon>
            {{ item.title }}
            <v-icon color="textSubtle" size="14" class="ml-1" v-if="item.subItems" icon="mdi-chevron-down"></v-icon>
          </v-btn>
        </template>
        <v-list class="main-menu-dropdown" aria-label="Navigation menu items leading to other parts of the website">
          <template v-for="subItem in item.subItems" :key="item.title + subItem.title + 'subItem'">
            <v-menu v-if="subItem.subItems" :open-on-hover="true" :open-on-click="true" location="right top"
                    role="menu">
              <template v-slot:activator="subActivator">
                <v-list-item v-bind="subActivator.props" :to="subItem.link" :aria-label="'Go to ' + subItem.title"
                             :class="subItem.link === currentRoute || subItem.subItems.filter(_ => _.link === currentRoute).length > 0 ? 'active' : ''"
                             role="menuitem">
                  {{ subItem.title }}
                  <v-icon color="textSubtle" size="14" class="ml-1" v-if="item.subItems" icon="mdi-chevron-right"></v-icon>
                </v-list-item>
              </template>
              <v-list class="main-menu-dropdown"
                      aria-label="Navigation menu items leading to other parts of the website">
                <v-list-item v-for="subSubItem in subItem.subItems"
                             :key="item.title + subSubItem.title + subItem.title + 'subItem'"
                             :to="subSubItem.link" :aria-label="'Go to ' + subSubItem.title" role="menuitem">
                  {{ subSubItem.title }}
                </v-list-item>
              </v-list>
            </v-menu>
            <v-list-item v-else
                         :to="subItem.link" :aria-label="'Go to ' + item.title" role="menuitem">
              {{ subItem.title }}
            </v-list-item>
          </template>
        </v-list>

      </v-menu>
      <v-badge location="top right" offset-x="10" offset-y="5" :model-value="item.badge > 0" :dot="false" size="x-small" v-else color="error">
        <template #badge>
          <div class="font-weight-bold" style="font-size: 10px;">{{ item.badge }}</div>
        </template>

        <v-btn  :key="item.title + 'item'" :to="item.link" role="menuitem">
          <v-icon :color="item.iconColor ?? 'primary'" size="14" class="mr-1" v-if="item.icon"
                  :icon="item.icon"></v-icon>
          {{ item.title }}
          <v-icon color="white" size="14" class="ml-1" v-if="item.subItems" icon="mdi-chevron-down"></v-icon>
        </v-btn>
      </v-badge>
    </template>
  </nav>
</template>

<style scoped lang="scss">
/* nav links: quiet ink-2 pills; active = brand tint (design kit .topbar-nav) */
.main-menu {
  .v-btn {
    color: rgb(var(--v-theme-charcoal));
    font-weight: 600;
  }

  .v-btn.active,
  .v-btn--active {
    color: rgb(var(--v-theme-primary));
    background: rgb(var(--v-theme-brandTint));
  }
}

@media (min-width: 960px) {
  .main-menu {
    .v-btn {
      font-size: 12px !important;
      padding: 0 10px;
    }

  }
}

@media (min-width: 1100px) {
  .main-menu {
    .v-btn {
      font-size: 13px !important;
      padding: 0 14px;
    }

  }
}
</style>
